import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonFooter, IonHeader, IonText, IonList, IonItem, IonDatetime, IonCheckbox } from '@ionic/react';

import { Plugins } from '@capacitor/core';

import '../../../css/layout.css';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { SelectDateRange_CheckIn } from './SelectDateRange_CheckIn';

import { SelectRoom } from './SelectRoom';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';


const { Storage } = Plugins;


async function removeStorageCredentials() {


    await Storage.remove({ key: 'accountID' });
    await Storage.remove({ key: 'employeeID' });
    await Storage.remove({ key: 'schemaName' });
    await Storage.remove({ key: 'isAuthenticated' });
    await Storage.remove({ key: 'accessRights' });
    await Storage.remove({ key: 'loginUsername_authenticated' });
    await Storage.remove({ key: 'loginPassword_authenticated' });
    await Storage.remove({ key: 'isBiometricFingerprintAvilable' });
    await Storage.remove({ key: 'biometricFingerprint' });
    await Storage.remove({ key: 'device' });
}

export function EnterCheckInInfoModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [uploadedFile, setUploadedFile ] = useState(null);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(new Date());
    let [endDate, setEndDate] = useState(new Date());
    let [numOfNights, setNumOfNights] = useState(null);
    let [displaySearch, setDisplaySearch] = useState('none');

    let [checkInRoomID, setCheckInRoomID] = useState(props.data.roomID);
    let [checkInRoomID_multiple, setCheckInRoomID_multiple] = useState(null);

    let [originalPrice, setOriginalPrice] = useState(props.data.roomSalePrice);
    let [roomSalePrice, setRoomSalePrice] = useState(props.data.roomSalePrice);
    let [roomSalePrice_multiple, setRoomSalePrice_multiple] = useState([]);


    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [discount, setDiscount] = useState(0);

    let [checkIn_Non_Member_ID_Type, setCheckIn_Non_Member_ID_Type] = useState('drivers_license')
    let [checkInMemberPaymentType, setCheckInMemberPaymentType ] = useState('cash');
    let [checkInNonMemberPaymentType, setCheckInNonMemberPaymentType ] = useState('cash');
    let [checkInCustomerStatus, setCheckInCustomerStatus ] = useState('non_member');
    //let [checkInAttachment, setCheckInAttachment ] = useState(null);
    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(null);

    const [mobileNumber, setMobileNumber] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    let [ccInfoDisplay, setCCInfoDisplay ] = useState('none');
    let [mmInfoDisplay, setMMInfoDisplay ] = useState('none');
    let [checkingInfoDisplay, setCheckingInfoDisplay ] = useState('none');
    let [cashInfoDisplay, setCashInfoDisplay ] = useState('inline-block');

    let [displaySetButton, setDisplaySetButton] = useState('inline-block');
    let [displayResetButton, setDisplayResetButton] = useState('none');

    let [disableCheckInButton, setDisableCheckInButton] = useState(false);
    let [disableSetButton, setDisableSetButton] = useState(false);
    let [disableResetButton, setDisableResetButton] = useState(false);
    let [taxStatus, setTaxStatus] = useState(true);

    //let selectCheckInDateRef = useRef();
    //let selectCheckOutDateRef = useRef();


    let enterQavaNumberRef = useRef(null);

    let enterMemberPaymentAmountRef = useRef();
    let enterFirstNameRef = useRef(null);
    let enterLastNameRef = useRef(null);
    let enterMobileNumberRef = useRef(null);
    let enterEmailRef = useRef(null);

    useEffect(() => {

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            //alert('After Response');
            //alert(data);

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setCheckInAttachment_ID(noImageFile);

        })

        
        
        if(props.data.status == 'bookToCheckIn' || props.data.status == 'bookToCheckIn_depositPaid')
        {

            let date1 = new Date(new Date(props.data.bookedStartDate));
            let date2 = new Date(new Date(props.data.bookedEndDate));
            let timeDiff = Math.abs(date2.getDate() - date1.getDate());
            let calcNumberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
    

            setStartDate(date1);
            setEndDate(date2);
            setNumOfNights(timeDiff);

            enterFirstNameRef.current.value = props.data.bookedFirstName;
            enterLastNameRef.current.value = props.data.bookedLastName;
            setMobileNumber(props.data.bookedPhoneNumber);
            enterEmailRef.current.value = props.data.bookedEmail;

        }
        else if(props.data.status == 'bookToCheckIn_multiple' || props.data.status == 'bookToCheckIn_depositPaid_multiple')
        {

            let date1 = new Date(new Date(props.data.bookedStartDate));
            let date2 = new Date(new Date(props.data.bookedEndDate));
            let timeDiff = Math.abs(date2.getDate() - date1.getDate());
            let calcNumberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
    

            setStartDate(date1);
            setEndDate(date2);
            setNumOfNights(timeDiff);

            enterFirstNameRef.current.value = props.data.bookedFirstName;
            enterLastNameRef.current.value = props.data.bookedLastName;
            setMobileNumber(props.data.bookedPhoneNumber);
            enterEmailRef.current.value = props.data.bookedEmail;

            onCheckInRoomID_multipleHandler(props.onCheckInRoomID_multiple);
            
        }

    }, [])

    let enterID_numberRef = useRef();
    
    let enterCC_numberRef = useRef();
    let enterCC_expDateRef = useRef();
    let enterCC_cvvNumberRef = useRef();
    let enterCC_addressRef = useRef();
    let enterCC_cityRef= useRef();
    let enterCC_stateRef = useRef();
    let enterCC_zipRef = useRef();
    let enterCC_nonMember_amountRef = useRef();

    let enterMM_displayRef = useRef();
    let selectMobileMoneyProviderRef = useRef();
    let enterMM_phoneNumberRef = useRef();
    let enterMM_nonMember_amountRef = useRef();


    let enterChecking_displayRef = useRef();
    let enterChecking_bankNameRef = useRef();
    let enterChecking_accountNumberRef = useRef();
    let enterChecking_routingNumberRef = useRef();
    let enterChecking_nonMember_amountRef = useRef();

    let enterCash_displayRef = useRef();
    let enterCash_amountRef = useRef();
    let enterDiscountRef = useRef(0);




    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setCheckInAttachment_ID(noImageFile);

            alert("No Attachment Option checked");

        })
    }

    function handleSelectIDType(e) {

        let event = [e[0], e[1].target.value];

        if(event[0] == 'member')
        {
            setCheckIn_Non_Member_ID_Type(event[1]);

        }
    }

    function handleSelectPaymentType(e) { 
        e[1].persist(); 
        //alert('In HandleSelectPaymentType');
        //alert(e);

        let event = [e[0], e[1].target.value];

        if(event[0] == 'member')
        {
            setCheckInCustomerStatus(event[0]);  

            if(event[1] == 'member')
            {
                setCheckInMemberPaymentType('none');   
            }
            else if(event[1] == 'cc' || event[1] == 'mm' || event[1] == 'cash' || event[1] == 'checking' )
            {
                setCheckInMemberPaymentType(event[1]);   

            }
        }

        else if(event[0] == 'non_member')
        {
            setCheckInCustomerStatus(event[0]);  

            
            if(event[1] == 'non_member')
            {
                setCheckInNonMemberPaymentType('none');   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            }
            else if(event[1] == 'cc')
            {

                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('inline-block');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            } 
            else if(event[1] == 'mm')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('inline-block');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            }
            else if(event[1] == 'checking')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('inline-block');   
                setCashInfoDisplay('none');   

            }
            else if(event[1] == 'cash')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('inline-block');   
            } 
        } 

      
    }

/*function searchGuest(tracker)
{

    let formData = new FormData();
    formData.append('Tracker', tracker);
    formData.append('user', acctID);
    formData.append('xSearchGuestData', searchGuestData);


    const requestOptions = {
        encType: 'multipart/form-data',
        method:'POST',
        credentials: 'include',
        files: formData,
        body: formData,
        contentType: false,
        processData: false,
    }

    
    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');

            if(cols[0] == 1)
            {
                if(cols[6] == 74117)
                {

                    this.setState(() => ({
                        guestSearch_byNameDisplay: 'inline-block',
                        checkInFirstName: cols[2],
                        checkInLastName: cols[3],
                        checkInMobileNumber: cols[4],
                        checkInEmail: cols[5],
    
                    }));
                }
                else if(cols[6] == 74127)
                {

                    this.setState(() => ({
                        guestSearch_byRoomDisplay: 'inline-block',
                        checkInFirstName: cols[2],
                        checkInLastName: cols[3],
                        checkInMobileNumber: cols[4],
                        checkInEmail: cols[5],
    
                    }));
                }
                else if(cols[6] == 74137)
                {

                    this.setState(() => ({
                        guestSearch_byPhoneDisplay: 'inline-block',
                        checkInFirstName: cols[2],
                        checkInLastName: cols[3],
                        checkInMobileNumber: cols[4],
                        checkInEmail: cols[5],
    
                    }));
                }

                this.setState(() => {
                        
                    let viewGuestSearchMatch = viewGuestSearchMatch.concat({
                        guestID: cols[1],
                        guestFirstName: cols[2],
                        guestLastName: cols[3],
                        guestPhoneNumber: cols[4],
                        guestEmail: cols[5],
                        //guestSchema: cols[6],
                    });
                    
                    return {
                        viewGuestSearchMatch,
                        value: {
                            guestID: cols[1],
                            guestFirstName: cols[2],
                            guestLastName: cols[3],
                            guestPhoneNumber: cols[4],
                            guestEmail: cols[5],
                            //guestSchema: cols[6],
                            },
                    };
                })

            }
            else if(cols[0] == 2 || cols[0] == 3)
            {
                this.setState(() => ({
                    guestSearchError: 'inline-block',
                    searchErrorMessage: cols[1],
                }));
            }

        } 
    })
    
}*/

function checkInGuest(e)
{

    e.preventDefault();

    //alert('In Check in guest');
    //alert(checkInAttachment_ID);
    //alert(sessionID);
    //alert(checkInNonMemberPaymentType);
    setDisableCheckInButton(true);

   /* let checkInToken = '';

    PushNotifications.checkPermissions().then((res) => {

        alert(Object.entries(res));
        alert(res.prompt);
        alert(res.receive);

        if (res.receive !== 'granted') {
          PushNotifications.requestPermissions().then((res) => {
            if (res.receive === 'denied') {
                alert('Push Notification permission denied');
            }
            else {
                alert('Push Notification permission granted');


                // Register with Apple / Google to receive push via APNS/FCM
                PushNotifications.register();

                // On success, we should be able to receive notifications
                PushNotifications.addListener('registration',
                    token => {
                        //showToast('Push registration success');
                        alert('ALERT TOKEN');
                        alert(token);
                        alert(Object.entries(token));
                        
                        checkInToken = token;

                    }
                );

                //showToast('After Push Notification addListener 1');
             // register();
            }
          });
        }
        else {
          //register();
          //PushNotifications.register();

                // Show us the notification payload if the app is open on our device
                PushNotifications.register();

                // On success, we should be able to receive notifications
                PushNotifications.addListener('registration',
                    token => {
                        //showToast('Push registration success');
                        alert('ALERT TOKEN');
                        alert(token);
                        alert(Object.entries(token));

                        checkInToken = token;

                    }
                );
            alert('After Push Notification addListener 2');

        }
      });*/


    let formData = new FormData();
    formData.append('user', acctID);
    formData.append('sessionID', sessionID);
    formData.append('xImageFile', checkInAttachment_ID);


    let _Tracker = '';
    let _checkInRoomID = '';
    let _checkInRoomID_multiple = '';
    let _bookingID = '';
    let _checkInDateBooked = '';
    let _checkOutDateBooked = '';
    let _checkInNonMemberPaymentAmount_multiple = '';
    let _checkInNonMemberPaymentAmount = '';


    if(checkInCustomerStatus == 'member')
    {
        formData.append('Tracker', 74105);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', checkInRoomID);
        //formData.append('xCheckInSalesPrice', checkInSalesPrice);
        formData.append('xSearchGuestData', enterQavaNumberRef.current.value);
        formData.append('xCheckInMemberPaymentType', null);
        formData.append('xCheckInMemberPaymentAmount', enterMemberPaymentAmountRef.current.value);
        formData.append('xCheckInDateBooked', startDate);
        formData.append('xCheckOutDateBooked', endDate);
        //formData.append('xCheckInDateBooked', selectCheckInDateRef.current.value);
        //formData.append('xCheckOutDateBooked', selectCheckOutDateRef.current.value);
        formData.append('xCheckInNumberOfNights', numOfNights);


    }
    else if(checkInCustomerStatus == 'non_member')
    {
        /*
        formData.append('user', acctID);
        */

        if(props.data.status == 'bookToCheckIn_depositPaid' || props.data.status == 'bookToCheckIn_depositPaid_multiple')
        {
            if(props.tracker == 74101)
            {
                if(checkInRoomID_multiple != null)
                {
                    /*
                    formData.append('Tracker', '4106_depositPaid_multiple');
                    formData.append('xBookingID', props.data.bookingID);
                    formData.append('xCheckInRoomID', checkInRoomID);
                    formData.append('xCheckInRoomID_multiple', checkInRoomID_multiple);
                    */

                    _Tracker = '4106_depositPaid_multiple';
                    _bookingID = props.data.bookingID;
                    _checkInRoomID = checkInRoomID;
                    _checkInRoomID_multiple = checkInRoomID_multiple;
                }
                else
                {
                    /*
                    formData.append('Tracker', '4106_depositPaid');
                    formData.append('xBookingID', props.data.bookingID);
                    formData.append('xCheckInRoomID', checkInRoomID);
                    */

                    _Tracker = '4106_depositPaid';
                    _bookingID = props.data.bookingID;
                    _checkInRoomID = checkInRoomID;
                }
            }
            else
            {

                if(checkInRoomID_multiple != null)
                {
                    /*
                    formData.append('Tracker', '4106_depositPaid_multiple');
                    formData.append('xBookingID', props.data.bookingID);
                    formData.append('xCheckInRoomID', checkInRoomID);
                    formData.append('xCheckInRoomID_multiple', checkInRoomID_multiple);
                    */

                    _Tracker = '4106_depositPaid_multiple';
                    _bookingID = props.data.bookingID;
                    _checkInRoomID = checkInRoomID;
                    _checkInRoomID_multiple = checkInRoomID_multiple;
                }
                else
                {
                    /*
                    formData.append('Tracker', '4106_depositPaid');
                    formData.append('xBookingID', props.data.bookingID);
                    formData.append('xCheckInRoomID', props.data.roomID);
                    */

                    _Tracker = '4106_depositPaid';
                    _bookingID = props.data.bookingID;
                    _checkInRoomID = checkInRoomID;
                }
            }  
        }
        else
        {

            if(props.tracker == 74101)
            {
                if(checkInRoomID_multiple != null)
                {
                    /*
                    formData.append('Tracker', '74106_multiple');
                    formData.append('xCheckInRoomID', checkInRoomID);
                    formData.append('xCheckInRoomID_multiple', checkInRoomID_multiple);
                    */

                    _Tracker = '74106_multiple';
                    _checkInRoomID = checkInRoomID;
                    _checkInRoomID_multiple = checkInRoomID_multiple;
                }
                else
                {
                    /*
                    formData.append('Tracker', 74106);
                    formData.append('xCheckInRoomID', checkInRoomID);
                    */

                    _Tracker = '74106';
                    _checkInRoomID = checkInRoomID;
                }
            }
            else
            {

                if(checkInRoomID_multiple != null)
                {
                    /*
                    formData.append('Tracker', '74106_multiple');
                    formData.append('xCheckInRoomID', checkInRoomID);
                    formData.append('xCheckInRoomID_multiple', checkInRoomID_multiple);
                    */

                    _Tracker = '74106_multiple';
                    _checkInRoomID = checkInRoomID;
                    _checkInRoomID_multiple = checkInRoomID_multiple;
                }
                else
                {
                    /*
                    formData.append('Tracker', 74106);
                    formData.append('xCheckInRoomID', props.data.roomID);
                    */

                    _Tracker = '74106';
                    _checkInRoomID = checkInRoomID;
                }
            }  
        }
        
        /*
        //formData.append('xCheckInSalesPrice', checkInSalesPrice);
        formData.append('xCheckInFirstName', enterFirstNameRef.current.value.replace(/\s+/g, '_'));
        formData.append('xCheckInLastName', enterLastNameRef.current.value.replace(/\s+/g, '_'));
        formData.append('xCheckInMobileNumber', enterMobileNumberRef.current.value.replace(/\s+/g, ''));
        formData.append('xCheckInEmail', enterEmailRef.current.value.replace(/\s+/g, ''));
        formData.append('xCheckInNonMemberIDType', checkIn_Non_Member_ID_Type);
        formData.append('xCheckInNonMemberIDNumber', enterID_numberRef.current.value);
        //formData.append('xCheckInAttachment_ID', checkInAttachment_ID);
        formData.append('xImageFile', checkInAttachment_ID);

        //formData.append('xCheckInAttachment', checkInAttachment);
        formData.append('xCheckInNonMemberPaymentType', checkInNonMemberPaymentType);
        */

        if(props.data.status == 'bookToCheckIn' || props.data.status == 'bookToCheckIn_depositPaid' || props.data.status == 'bookToCheckIn_multiple' || props.data.status == 'bookToCheckIn_depositPaid_multiple')
        {
            /*
            formData.append('xCheckInDateBooked', startDate.toISOString().substr(0, 10));
            formData.append('xCheckOutDateBooked', endDate.toISOString().substr(0, 10));
            */

            _checkInDateBooked = startDate.toISOString().substr(0, 10);
            _checkOutDateBooked = endDate.toISOString().substr(0, 10);
        }
        else
        {
            /*
            formData.append('xCheckInDateBooked', startDate);
            formData.append('xCheckOutDateBooked', endDate);
            */

            _checkInDateBooked = startDate;
            _checkOutDateBooked = endDate;
        }
        
        //formData.append('xCheckInDateBooked', selectCheckInDateRef.current.value);
        //formData.append('xCheckOutDateBooked', selectCheckOutDateRef.current.value);
        /*
        formData.append('xCheckInNumberOfNights', numOfNights);
        */

            if(checkInNonMemberPaymentType == 'none')
            {
                if(props.tracker == 74101)
                {
                    if(checkInRoomID_multiple != null)
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount_multiple', roomSalePrice_multiple);
                        */

                        _checkInNonMemberPaymentAmount_multiple = roomSalePrice_multiple;
                    }
                    else
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount', parseFloat(roomSalePrice).toFixed(2));
                        */

                        _checkInNonMemberPaymentAmount = parseFloat(roomSalePrice).toFixed(2);
                    }
                }
                else
                {
                    if(checkInRoomID_multiple != null)
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount_multiple', roomSalePrice_multiple);
                        */

                        _checkInNonMemberPaymentAmount_multiple = roomSalePrice_multiple;

                    }
                    else
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount', parseFloat(roomSalePrice).toFixed(2));
                        */
                       
                        _checkInNonMemberPaymentAmount = parseFloat(roomSalePrice).toFixed(2);

                    }
                }
            } 
            /*
            else if(checkInNonMemberPaymentType == 'cc')
            {
                formData.append('xCheckInCreditCardNumber', enterCC_numberRef.current.value);
                formData.append('xCheckInCreditCardExpDate', enterCC_expDateRef.current.value);
                formData.append('xCheckInCreditCardCvvNumber', enterCC_cvvNumberRef.current.value);
                formData.append('xCheckInCreditCardAddress', enterCC_addressRef.current.value);
                formData.append('xCheckInCreditCardCity', enterCC_cityRef.current.value);
                formData.append('xCheckInCreditCardState', enterCC_stateRef.current.value);
                formData.append('xCheckInCreditCardZipCode', enterCC_zipRef.current.value);
                formData.append('xCheckInNonMemberPaymentAmount', enterCC_nonMember_amountRef.current.value);
      
            } 
            else if(checkInNonMemberPaymentType == 'mm')
            {
                formData.append('xCheckInMobileMoneyProvider', selectMobileMoneyProviderRef.current.value);
                formData.append('xCheckInMobileMoneyPhoneNumber', enterMM_phoneNumberRef.current.value);
                formData.append('xCheckInNonMemberPaymentAmount', enterMM_nonMember_amountRef.current.value);
            }
            else if(checkInNonMemberPaymentType == 'checking')
            {
                formData.append('xCheckInBankName', enterChecking_bankNameRef.current.value);
                formData.append('xCheckInAccountNumber', enterChecking_accountNumberRef.current.value);
                formData.append('xCheckInRoutingNumber', enterChecking_routingNumberRef.current.value);
                formData.append('xCheckInNonMemberPaymentAmount', enterChecking_nonMember_amountRef.current.value);
            }
            */
            else if(checkInNonMemberPaymentType == 'cash')
            {
                if(props.tracker == 74101)
                {
                    if(checkInRoomID_multiple != null)
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount_multiple', roomSalePrice_multiple);
                        */

                        _checkInNonMemberPaymentAmount_multiple = roomSalePrice_multiple;

                    }
                    else
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount', parseFloat(roomSalePrice).toFixed(2)); 
                        */

                        _checkInNonMemberPaymentAmount = parseFloat(roomSalePrice).toFixed(2);

                    }
                }
                else
                {
                    if(checkInRoomID_multiple != null)
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount_multiple', roomSalePrice_multiple);
                        */

                        _checkInNonMemberPaymentAmount_multiple = roomSalePrice_multiple;

                    }
                    else
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount', parseFloat(roomSalePrice).toFixed(2));
                        */

                        _checkInNonMemberPaymentAmount = parseFloat(roomSalePrice).toFixed(2);

                    }
                }
            }

    }


    const requestOptions0 = {
        encType: 'multipart/form-data',
        method:'POST',
        //credentials: 'include',
        /*headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },*/
        //files: formData,
        body: formData,
        /*body: JSON.stringify({
            user: acctID,
            sessionID: sessionID,
        }),*/
        //contentType: false,
        //processData: false,
    }
    

    /*
    const requestOptions = {
        encType: 'multipart/form-data',
        method:'POST',
        credentials: 'include',
        files: formData,
        body: formData,
        contentType: false,
        processData: false,
    }
    */


    fetch(baseURL+'upload', requestOptions0)
    .then(res => res.text())
    .then(res => {


        setUploadedFile(res.toString());


        const requestOptions = {
            encType: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            files: formData,
            body: JSON.stringify({
                Tracker: _Tracker,
                user: acctID,
                fmc_schema: authenticatedMerchent_context.schema,
                //xCheckInSalesPrice: checkInSalesPrice,
                xCheckInFirstName: enterFirstNameRef.current.value.replace(/\s+/g, '_'),
                xCheckInLastName: enterLastNameRef.current.value.replace(/\s+/g, '_'),
                xCheckInMobileNumber: mobileNumber.replace(/\s+/g, ''),
                xCheckInEmail: enterEmailRef.current.value.replace(/\s+/g, ''),
                xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                //xCheckInAttachment_ID: checkInAttachment_ID,
                //xImageFile: checkInAttachment_ID,
                //xCheckInAttachment: checkInAttachment,
                xCheckInNonMemberPaymentType: checkInNonMemberPaymentType,
                xCheckInCreditCardNumber: enterCC_numberRef.current.value,
                xCheckInCreditCardExpDate: enterCC_expDateRef.current.value,
                xCheckInCreditCardCvvNumber: enterCC_cvvNumberRef.current.value,
                xCheckInCreditCardAddress: enterCC_addressRef.current.value,
                xCheckInCreditCardCity: enterCC_cityRef.current.value,
                xCheckInCreditCardState: enterCC_stateRef.current.value,
                xCheckInCreditCardZipCode: enterCC_zipRef.current.value,
                xCheckInMobileMoneyProvider: selectMobileMoneyProviderRef.current.value,
                xCheckInMobileMoneyPhoneNumber: enterMM_phoneNumberRef.current.value,
                xCheckInBankName: enterChecking_bankNameRef.current.value,
                xCheckInAccountNumber: enterChecking_accountNumberRef.current.value,
                xCheckInRoutingNumber: enterChecking_routingNumberRef.current.value,
    
                xBookingID: _bookingID,
                xCheckInRoomID: _checkInRoomID,
                xCheckInRoomID_multiple: _checkInRoomID_multiple,
                xCheckInDateBooked: _checkInDateBooked,
                xCheckOutDateBooked: _checkOutDateBooked,
                xCheckInNonMemberPaymentAmount: _checkInNonMemberPaymentAmount,
                xCheckInNonMemberPaymentAmount_multiple: _checkInNonMemberPaymentAmount_multiple,
                xCheckInNumberOfNights: numOfNights,
                sessionID: sessionID,
                xCheckInAttachment: res.toString(),
                //xCheckInToken: checkInToken,
                xTaxStatus: taxStatus,

    
            }),
            contentType: false,
            processData: false,
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
    
            if(res != 0)
            {
                let rows = res.toString().split('~~~');
    
                alert(res);
        
                if(props.data.status == 'bookToCheckIn' || props.data.status == 'bookToCheckIn_depositPaid' || props.data.status == 'bookToCheckIn_multiple' || props.data.status == 'bookToCheckIn_depositPaid_multiple')
                {
                    //setShowPasswordModal(true);
                    deleteBooking();
                }
                else
                {
                    props.closeModal(false);
        
                }
        
            }
            else if(res == 0)
            {
                alert('You have been automatically logged out.  Please Log Back In');
    
                removeStorageCredentials();
    
                window.location.href = 'https://ghanaverified.com';
            }
    
        })
        
    })

}
function displaySearchMatchHandler() {
    setDisplaySearch('inline-block');
}

function onCheckInRoomIDHandler(event) {


    //props.onCheckInRoomID(event);
    setCheckInRoomID(event.selectedRoomID);
        setCheckInRoomID_multiple(null);
    setRoomSalePrice(event.selectedRoomSalesPrice);
}

function onCheckInRoomID_multipleHandler(event) 
{


    //setBookingType(event.selectedBookingType);
    setCheckInRoomID_multiple(event.selectedRoomID);
    setRoomSalePrice_multiple(event.selectedRoomSalesPrice);
    //setBookingPrice_multiple(event.selectedRoomSalesPrice);

    let totalCheckInPrice = 0.00;
    for(let col = 0; col < event.selectedRoomID.length; ++col)
    {

        totalCheckInPrice = parseFloat(Number(totalCheckInPrice) + Number(event.selectedRoomSalesPrice[col])).toFixed(2);

    }

    setRoomSalePrice(totalCheckInPrice);
    setOriginalPrice(totalCheckInPrice);

}

function onCheckInDateHandler_fromBooked(event) {


    let date1 = new Date(new Date(event[0]));
    let date2 = new Date(new Date(event[1]));
    let timeDiff = Math.abs(date2.getTime() - date1.getTime());
    let calcNumberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24)); 


    setStartDate(date1);
    setEndDate(date2);
    setNumOfNights(calcNumberOfNights);

}

function onCheckInDateHandler(event) {


    //selectCheckInDateRef = event.startDate;
    //selectCheckOutDateRef = event.endDate;
    setStartDate(event.startDate);
    setEndDate(event.endDate);
    setNumOfNights(event.numOfNights);

}

function setDiscountHandler()
{
    setDisableSetButton(true);
    setDisplaySetButton('none');
    setDisplayResetButton('inline-block');
    setRoomSalePrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
    setDisableResetButton(false);

    if(props.tracker == 74101)
    {
        let newRoomSalesPrice_Multiple = [];

        for(let i = 0; i < roomSalePrice_multiple.length; ++i)
        {
            newRoomSalesPrice_Multiple.push(roomSalePrice_multiple[i] - (roomSalePrice_multiple[i]*(enterDiscountRef.current.value/100)));
        }
        
        setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);
    }
}

function resetDiscountHandler()
{
    setDisableResetButton(true);
    setDisplaySetButton('inline-block');
    setDisplayResetButton('none');
    setRoomSalePrice(originalPrice);

    if(checkInRoomID_multiple != null)
    {
        setRoomSalePrice_multiple(originalPrice);
    }
    enterDiscountRef.current.value = '';
    setDisableSetButton(false);
}

function handleShortTime()
{
    if(document.getElementById('shortTime').checked == true)
    {
        setStartDate(new Date().toISOString().substr(0, 10));
        setEndDate(new Date().toISOString().substr(0, 10));
        setNumOfNights(1);
        enterDiscountRef.current.value = '0.00';
        enterFirstNameRef.current.value = 'NO';
        enterLastNameRef.current.value = 'NAME';
        setMobileNumber('00000');
        enterEmailRef.current.value = 'no_email';
        enterID_numberRef.current.value = '00000';
        setRoomSalePrice(50.00);
        setDisableSetButton(true);

    }
    else
    {
        setStartDate(new Date().toISOString().substr(0, 10));
        setEndDate(new Date().toISOString().substr(0, 10));
        setNumOfNights(0);
        enterDiscountRef.current.value = '';
        enterFirstNameRef.current.value = '';
        enterLastNameRef.current.value = '';
        setMobileNumber('');
        enterEmailRef.current.value = '';
        enterID_numberRef.current.value = '';
        setRoomSalePrice(props.data.roomSalePrice);
        setDisableSetButton(false);

    }

}

function deleteBooking(enteredPassword)
{

    /*let formData = new FormData();
    formData.append('Tracker', 74193);
    formData.append('user', acctID);
    formData.append('xInventoryRoomID', props.data.roomID);
    formData.append('xBookingID', props.data.bookingID);
    //formData.append('xEnterAdminPassword', enteredPassword);


    const requestOptions = {
        enctype: 'multipart/form-data',
        method:'POST',
        credentials: 'include',
        files: formData,
        body: formData,
        contentType: false,
        processData: false,
    }
    */

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: 74193,
            user: acctID,
            xInventoryRoomID: props.data.roomID,
            xBookingID: props.data.bookingID,
            sessionID: sessionID,

        }),
    }

    
    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        alert(res);

    })

    props.closeModal(false);

}

function onSubmitPasswordHandler(event)
{

    deleteBooking(event);
}

function handleMobileNumberChange(e) {

    const IonInput = e.detail.value || '';
    if (!IonInput.startsWith('0')) {
        setErrorMessage('Mobile number must start with 0.');
    } else {
        setErrorMessage('');
    }
    setMobileNumber(IonInput);
};

function closeModalHandler(event) {

    //alert('Inside closeModalHandler');
    props.closeModal(event);
}

//alert(authenticatedMerchent_context.device);

return (
    <React.Fragment>
    {props.openModal == true ?
        (
    <IonModal isOpen={ props.openModal }>
        <form onSubmit={checkInGuest}>

        <IonHeader style={{ color: "black" }}>
            <IonGrid>
                <IonRow>
                    <IonCol size='12'>
                        <h4>CHECK-IN GUEST</h4>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>
        <IonGrid >
            {props.tracker != 74101 ? 
            (
                <React.Fragment>
                    <IonRow>
                        <IonCol size='4'> Room ID</IonCol>
                        <IonCol size='4'> Short </IonCol>
                        <IonCol size='4'> Price Per Night</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='4'> {props.data.roomID} </IonCol>
                        <IonCol size='4'> <input type='checkbox' id='shortTime' onClick={(e) => handleShortTime()}></input> </IonCol>
                        <IonCol size='4'> {props.data.roomSalePrice} </IonCol>
                    </IonRow>

                    {(props.data.status != 'bookToCheckIn' && props.data.status != 'bookToCheckIn_depositPaid' && props.data.status != 'bookToCheckIn_multiple' && props.data.status != 'bookToCheckIn_depositPaid_multiple') && <SelectDateRange_CheckIn onCheckInDate={onCheckInDateHandler}></SelectDateRange_CheckIn>}

                    {(props.data.status == 'bookToCheckIn' || props.data.status == 'bookToCheckIn_depositPaid' || props.data.status == 'bookToCheckIn_multiple' || props.data.status == 'bookToCheckIn_depositPaid_multiple') && 
                    <React.Fragment> 
                    <IonRow>
                        <IonCol size='4'>
                            <IonText style={{ fontSize: ".5em !important", padding: '20px 40px' }}>CHECK-IN</IonText>
                        </IonCol>
                        <IonCol size='4'>
                            <IonText style={{ fontSize: ".5em !important", padding: '20px 40px' }}>Nights: </IonText>
                        </IonCol>
                        <IonCol size='4'>
                            <IonText style={{ fontSize: ".5em !important", padding: '20px 40px' }}>CHECK-OUT</IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                           {/* {authenticatedMerchent_context.device == 'mobile' && <IonDatetime displayFormat='MMM DD, YYYY' placeholder={startDate.toLocaleString('en-us', {month: 'short', day: '2-digit'})+', '+startDate.getFullYear()} onIonChange={(e) => onCheckInDateHandler_fromBooked([new Date(e.target.value), endDate])}>  </IonDatetime> } */}
                           {authenticatedMerchent_context.device == 'mobile'&&  <IonInput type='date' value={startDate.toISOString().substr(0, 10)} onIonChange={(e)=> onCheckInDateHandler_fromBooked([new Date(e.target.value), endDate])}>  </IonInput>  }
                            {(authenticatedMerchent_context.device == 'desktop' || authenticatedMerchent_context.device == null) &&  <IonInput type='date' value={startDate.toISOString().substr(0, 10)} onIonChange={(e)=> onCheckInDateHandler_fromBooked([new Date(e.target.value), endDate])}> </IonInput>  }
                        </IonCol>
                        <IonCol>
                            <p>{numOfNights}</p>
                        </IonCol>
                        <IonCol>                    
                           {/* {authenticatedMerchent_context.device == 'mobile' && <IonDatetime displayFormat='MMM DD, YYYY' placeholder={endDate.toLocaleString('en-us', {month: 'short', day: '2-digit'})+', '+endDate.getFullYear()} onIonChange={(e) => onCheckInDateHandler_fromBooked([startDate, new Date(e.target.value)])}>  </IonDatetime> } */}
                           {authenticatedMerchent_context.device == 'mobile' &&  <IonInput type='date' value={endDate.toISOString().substr(0, 10)} onIonChange={(e)=> onCheckInDateHandler_fromBooked([startDate, new Date(e.target.value)])}>  </IonInput>  }

                            {(authenticatedMerchent_context.device == 'desktop' || authenticatedMerchent_context.device == null) && <IonInput type='date' value={endDate.toISOString().substr(0, 10)} onIonChange={(e)=> onCheckInDateHandler_fromBooked([startDate, new Date(e.target.value)])}> </IonInput>  }
                        </IonCol>
                    </IonRow> 
                    </React.Fragment>}

                </React.Fragment>) :

            (<SelectRoom openModal={ props.openModal } onCheckInRoomID= { onCheckInRoomIDHandler} onCheckInRoomID_multiple={onCheckInRoomID_multipleHandler} onCheckInDate={onCheckInDateHandler} selectRoomTracker={'74701B'} tracker={74701} ></SelectRoom>)
            }
            {/*<IonRow>
                <IonCol> ghanaverified Member </IonCol>
                <IonCol> Non-Member </IonCol>
            </IonRow>*/} 
        {/*<IonSlide>
            <IonGrid>
                <IonRow>
                    <IonCol>qava Number:</IonCol>
                    <IonCol>
                        <IonInput placeholder='Search Member by Phone' ref={enterQavaNumberRef }></IonInput>
                    </IonCol>
                    <IonCol>
                        <IonButton  onClick={displaySearchMatchHandler}> Search </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        {
                            enterQavaNumberRef.current != null ?
                            (
                                <IonCard style={{display: displaySearch}}>
                                    <GetGuestSearchMatch tracker={74107} searchGuestData={enterQavaNumberRef.current.value}></GetGuestSearchMatch>
                                </IonCard>
                            ) : null
                        }
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel htmlFor="QavaPaymentType">Payment Type </IonLabel>
                        <select name="QavaPaymentType" id='QavaPaymentType' onChange={(e) => handleSelectPaymentType(['member', e]) }>
                            <option value='member'>Select</option>
                            <option value='cc'>Credit Card</option>
                            <option value='mm'>Mobile Money</option>
                            <option value='checking'>Checking</option>
                            <option value='cash' selected='selected'>Cash</option>
                        </select>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Amount: </IonLabel>
                            <IonInput placeholder='Enter Payment Amount' ref={enterMemberPaymentAmountRef }></IonInput>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonSlide>*/}    
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel>First Name: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterFirstNameRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel>Last Name: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterLastNameRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="6">
                        <label htmlFor="mobileNumber">Mobile Number:</label>
                    </IonCol>
                    <IonCol size="6">
                        <IonInput
                            className='professional-input'
                            id="mobileNumber"
                            placeholder="Enter mobile number"
                            type="tel"
                            value={mobileNumber}
                            maxlength={10}
                            onIonChange={(e) => handleMobileNumberChange(e)}
                            required/>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel>Email: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterEmailRef}></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel htmlFor="paymenttype">ID Type </IonLabel>                                    
                    </IonCol>
                    <IonCol size='6'>
                        <select name="paymenttype" id='paymenttype' onChange={(e) => handleSelectIDType(['non_member', e]) }>
                            <option value='ghana_id'>GhanaID</option>
                            <option value='drivers_license' selected='selected'>Drivers License</option>
                            <option value='passport'>Passport</option>
                        </select>
                    </IonCol>
                </IonRow>
                <IonRow>  
                    <IonCol size='6'>                                              
                        <IonLabel>ID Number: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterID_numberRef }></IonInput>
                    </IonCol> 
                </IonRow>
                <IonRow>
                    <IonCol>
                        <form id='fileUpload' encType='multipart/form-data'>
                            <label htmlFor='checkInAttachment_ID'>ID Photo</label>
                                <input id='checkInAttachment_ID' type='file' name='imageFile' accept="image/*" onChange={(e) => setCheckInAttachment_ID(e.target.files[0])}></input>
                            <label htmlFor='noAttachment_ID'>Customer Denied Photo</label>
                                <input type='checkbox' id='noAttachment_ID' onClick={() => handleEnterAttachement()}></input>
                        </form>                                        
                    </IonCol>
                </IonRow>
                {/*<IonRow>
                    <IonCol>
                        <form id='fileUpload' encType='multipart/form-data'>
                            <label htmlFor='checkInAttachment'>Attachment</label>
                                <input id='checkInAttachment' type='file' name='imageFile' accept="image/*" onChange={(e) => handleEnterAttachement(e)}></input>
                            <label htmlFor='noAttachment'>No Attachment</label>
                                <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => handleEnterAttachement(e)}></input>
                        </form>                                        
                    </IonCol>
                </IonRow>*/}
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel htmlFor="paymenttype">Payment Type </IonLabel>                                    
                    </IonCol>
                    <IonCol size='6'>
                        <select name="paymenttype" id='paymenttype' onChange={(e) => handleSelectPaymentType(['non_member', e]) }>
                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <option value='cc'>Credit Card</option>}
                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <option value='mm'>Mobile Money</option>}
                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <option value='checking'>Checking</option>}
                            <option value='cash' selected='selected'>Cash</option>
                        </select>
                    </IonCol>
                </IonRow>
                <IonRow style={{display: ccInfoDisplay}}>
                    <IonCol size='6'>                        
                        <IonLabel>Credit Card Number: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterCC_numberRef }></IonInput>
                    </IonCol>
                </IonRow >
                <IonRow style={{display: ccInfoDisplay}}>  
                    <IonCol size='6'>                                              
                        <IonLabel>Exp Date: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterCC_expDateRef }></IonInput>
                    </IonCol> 
                </IonRow>
                <IonRow style={{display: ccInfoDisplay}}>    
                    <IonCol size='6'>
                        <IonLabel>Cvv: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterCC_cvvNumberRef }></IonInput>
                    </IonCol> 
                </IonRow>
                <IonRow style={{display: ccInfoDisplay}}>    
                    <IonCol size='6'>
                        <IonLabel>Address: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterCC_addressRef }></IonInput>
                    </IonCol> 
                </IonRow>
                <IonRow style={{display: ccInfoDisplay}}> 
                    <IonCol size='6'>   
                        <IonLabel>City: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterCC_cityRef }></IonInput>
                    </IonCol> 
                </IonRow>
                <IonRow style={{display: ccInfoDisplay}}>    
                    <IonCol size='6'>
                        <IonLabel>state: </IonLabel>
                    </IonCol>
                    <IonCol>
                        <IonInput placeholder='Enter' ref={enterCC_stateRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow style={{display: ccInfoDisplay}}>     
                    <IonCol size='6'>
                        <IonLabel>Zip Code: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={ enterCC_zipRef}></IonInput>
                    </IonCol> 
                </IonRow>
                <IonRow style={{display: ccInfoDisplay}}> 
                    <IonCol size='6'>   
                        <IonLabel>Amount: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterCC_nonMember_amountRef }></IonInput>
                    </IonCol>    
                </IonRow>
                <IonRow style={{display: mmInfoDisplay}}>
                    <IonCol size='6'>                        
                        <IonLabel htmlFor="mmProvider">Mobile Money Provider: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <select name="mmProvider" id='mmProvider' ref={selectMobileMoneyProviderRef}>
                            <option value='none'>Select</option>
                            <option value='mtn'>mtn</option>
                            <option value='vodafone'>vodafone</option>
                            <option value='private'>Private</option>
                        </select>
                    </IonCol>
                </IonRow>
                <IonRow style={{display: mmInfoDisplay}}>
                    <IonCol size='6'>                        
                        <IonLabel>Mobile Phone Number: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={ enterMM_phoneNumberRef  }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow style={{display: mmInfoDisplay}}>
                    <IonCol size='6'>                        
                        <IonLabel>Amount: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={ enterMM_nonMember_amountRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow style={{display: checkingInfoDisplay}}>
                    <IonCol size='6'>                        
                        <IonLabel htmlFor="checkingProvider">Bank Name: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterChecking_bankNameRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow style={{display: checkingInfoDisplay}}>
                    <IonCol size='6'>                        
                        <IonLabel>Checking Account Number: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterChecking_accountNumberRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow style={{display: checkingInfoDisplay}}>
                    <IonCol size='6'>                        
                        <IonLabel>Routing Number: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={enterChecking_routingNumberRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow style={{display: checkingInfoDisplay}}>
                    <IonCol size='6'>                        
                        <IonLabel>Amount: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <IonInput placeholder='Enter' ref={ enterChecking_nonMember_amountRef }></IonInput>
                    </IonCol>
                </IonRow>
                {/*<IonRow style={{display: cashInfoDisplay}}>*/}
                <IonRow>
                    <IonCol size='4'>
                        <h4>Discount: </h4>
                    </IonCol>
                    <IonCol size='4'>
                        <IonInput style={{display: displaySetButton}} type='number' placeholder='Enter %' ref={enterDiscountRef}></IonInput>
                        <h4 style={{display: displayResetButton}}>{enterDiscountRef.current.value+' %'}</h4>
                    </IonCol>
                    <IonCol size='4'> 
                        <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDiscountHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDiscountHandler()}>Reset</IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonText>NO TAX</IonText>
                    </IonCol>
                    <IonCol>
                        <IonCheckbox checked={taxStatus} onIonChange={() => setTaxStatus(!taxStatus)}> NO TAX </IonCheckbox>                         
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'>
                        <h4>Check-In Price: </h4>
                    </IonCol>
                    <IonCol size='6'>
                        <h4>{parseFloat(roomSalePrice).toFixed(2)}</h4>
                        {/*<IonInput type='number' placeholder='Enter Discount Amount' ref={enterCash_amountRef }></IonInput>*/}

                    </IonCol>
                </IonRow>
            </IonGrid>
    </IonContent>

            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>


            <IonButton type='submit' className='grid_checkInFooter_left' disabled={disableCheckInButton}> Confirm Check-In </IonButton>
            <IonButton className='grid_checkInFooter_right' onClick={() => closeModalHandler(false)}> Cancel </IonButton>
    </form>
    </IonModal>
    ) : null}
    </React.Fragment>)
}